import "./App.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WebRoutes from "./webRoutes";
import { Provider } from "react-redux";
import { makeStore } from "./pages/app/lib/store.tsx";
import AdminLayout from "./pages/app/admin_layout.jsx";
import AdminRoutes from "./adminRoutes.jsx";

export default function App() {
  const store = makeStore();

  return (
    <div>
      <Provider store={store}>
        <ToastContainer />
        {/* <WebRoutes /> */}
        {/* <AdminLayout /> */}
        <AdminRoutes />
      </Provider>
    </div>
  );
}
